import { render } from "./PageNotFound.vue?vue&type=template&id=e95fcc4c&scoped=true"
import script from "./PageNotFound.vue?vue&type=script&lang=js"
export * from "./PageNotFound.vue?vue&type=script&lang=js"

import "./PageNotFound.vue?vue&type=style&index=0&id=e95fcc4c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Administrateur\\Documents\\davca-cm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e95fcc4c"]])

export default __exports__